import './sb';
import 'datatables.net/js/jquery.dataTables.js';
import 'datatables.net-responsive/js/dataTables.responsive.js';
import 'datatables.net-bs4/js/dataTables.bootstrap4.js';
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.js';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import Vuetify from 'vuetify';
import moment from 'moment-timezone';
import '@fortawesome/fontawesome-free/js/all';
import Vuex from 'vuex';
import VueToast from 'vue-toast-notification';
import store from './store';

import 'vue-toast-notification/dist/theme-sugar.css';

window.$ = window.jQuery = require('jquery');

require('./bootstrap');

window.Vue = Vue;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(datePicker);
Vue.use(Vuetify);
Vue.use(VueToast);

Vue.component('AdminResultLimit', require('./components/result/admin-result-limit.vue').default);

Vue.component('AdminLoan', require('./components/loan/admin-loan.vue').default);

Vue.component('BetButtonGroup', require('./components/lotto/bet-button-group.vue').default);
Vue.component('ButtonItem', require('./components/lotto/button-item.vue').default);
Vue.component('Countdown', require('./components/countdown.vue').default);
Vue.component('LottoReview', require('./components/lotto/lotto-review.vue').default);
Vue.component('PickDigit', require('./components/lotto/pick-digit.vue').default);
Vue.component('PointAmount', require('./components/point-amount.vue').default);
Vue.component('Result', require('./components/lotto/result.vue').default);
Vue.component('ResultItem', require('./components/lotto/result-item.vue').default);
Vue.component('BetList', require('./components/lotto/bet-list.vue').default);
Vue.component('BetRecap', require('./components/lotto/bet-recap.vue').default);
Vue.component('Shoot', require('./components/lotto/shoot.vue').default);
Vue.component('ConvertThaidate', require('./components/convert-thaidate.vue').default);

Vue.component('IndexLotto', require('./components/lotto/index-lotto.vue').default);

Vue.component('LottoResults', require('./components/lotto/lotto-results.vue').default);
Vue.component('LottoReward', require('./components/lotto-reward/lotto-reward.vue').default);
Vue.component('CashRequest', require('./components/user-cash/cash-request.vue').default);
Vue.component('CashInput', require('./components/user-cash/cash-input.vue').default);

Vue.component('AffInput', require('./components/user-aff/aff-input.vue').default);
Vue.component('AffMember', require('./components/user-aff/aff-member.vue').default);
Vue.component('ShootList', require('./components/lotto/shoot-list.vue').default);

Vue.component('BetSet', require('./components/lotto/bet-set.vue').default);
Vue.component('SoidownItem', require('./components/lotto/soidown-item.vue').default);
Vue.component('SoidownPage', require('./components/lotto/soidown-page.vue').default);
Vue.component('UserMessageList', require('./components/user-messages/message-list.vue').default);

Vue.component('AgentMessenger', require('./components/agent-messages/messenger.vue').default);
Vue.component('ModalButton', require('./components/modal-button.vue').default);
Vue.component('NotificationMenu', require('./components/notification-menu/menu.vue').default);
Vue.component('NotificationBell', require('./components/notification-bell.vue').default);
Vue.component('UserNotifications', require('./components/user-notifications/user-notifications.vue').default);
Vue.component('CashTable', require('./components/cash-table.vue').default);
Vue.component('CreditTable', require('./components/credit-table.vue').default);
Vue.component('PointTable', require('./components/point-table.vue').default);
Vue.component('CreditAdminTable', require('./components/credit-admin-table.vue').default);
Vue.component('MemberTable', require('./components/member-management/member-table.vue').default);
Vue.component('CreditType', require('./components/credit-type.vue').default);
Vue.component('PointType', require('./components/point-type.vue').default);
Vue.component('CreditTypeAdmin', require('./components/credit-type-admin.vue').default);

Vue.component('UserMemberTable', require('./components/user-member-table.vue').default);

Vue.component('TicketAdminTable', require('./components/ticket-admin-table.vue').default);

Vue.component('TicketNumberAll', require('./components/ticket-number-all.vue').default);

Vue.component('TicketNumberTable', require('./components/ticket-number-table.vue').default);

Vue.component('TicketNumberTop', require('./components/ticket-number-top.vue').default);

Vue.component('TicketTable', require('./components/ticket-table.vue').default);

Vue.component('ReportGameDaily', require('./components/report/game-daily.vue').default);

Vue.component('ReportCashAgentDaily', require('./components/report/cash-agent-daily.vue').default);

Vue.component('ReportCreditSystemDaily', require('./components/report/credit-system-daily.vue').default);

Vue.component('UserAffTable', require('./components/user-aff/aff-table.vue').default);

Vue.mixin({
  methods: {
    maskingUsername(username) {
      return (
        username.substr(0, 3)
        + '⌁'.repeat(Math.max(username.length - 4, 1))
        + username.substr(-1)
      ).toLocaleLowerCase();
    },

    toast(digits) {
      this.$toast.open({
        message: `เพิ่ม ${digits}`,
        type: 'success',
        duration: 3000,
        position: 'top-right',
      });
    },
  },
});
Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});
Vue.prototype.$moment = moment;
const app = new Vue({
  el: '#app',
  store,
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          anchor: 'auto',
        },
      },
    },
  }),
  components: {
    SoundIdenticator: require('./components/sound-identicator').default,
    NotificationBadge: require('./components/notification-badge').default,
  },
  mounted() {},

  created() {
    // replace state
    const newState = { ...store.state };
    const messages = { ...newState.user.messages };
    newState.user = window.appState.user;
    newState.user.messages = messages;
    store.replaceState(newState);
  },
});

window.vm = app;
const checkboxController = document.getElementById('checkboxController');
if (checkboxController) {
  checkboxController.addEventListener('click', () => {
    const ctrls = checkboxController.getAttribute('data-control');
    if (ctrls) {
      document.getElementsByName(ctrls).forEach((ctrl) => (ctrl.checked = checkboxController.checked));
    }
  });
}
if (document.getElementById('sidebarToggle')) {
  document.getElementById('sidebarToggle').addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementsByTagName('body')[0].classList.toggle('sidenav-toggled');
  });
}

window.numberFormat = (number) => number.toLocaleString('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
